import.meta.glob("./action_bar/*.{js,hbs,jst.ejs}", { eager: true });

window.Sparkle ??= {};
window.Sparkle.PageBuilder ??= {};
window.Sparkle.PageBuilder.Component ??= {};

// VITE_MIGRATION: preserve sub-properties (e.g. .Action) attached by
// glob-imported children under ./action_bar/ before this file's body
// overwrites ActionBar with the class definition. The eager glob on
// line 1 hoists those children above the body assignment under ESM.
var _previousActionBar = Sparkle.PageBuilder.Component.ActionBar;

Sparkle.PageBuilder.Component.ActionBar = class ActionBar {
  constructor() {
    this.render = this.render.bind(this);
    this.clearActions = this.clearActions.bind(this);
    this.addAction = this.addAction.bind(this);
    this.addBadge = this.addBadge.bind(this);
    this.el = jQuery('<div class="component-action-bar"></div>');
    this.actionContainer = jQuery('<div class="actions"></div>');
    this.badgeContainer = jQuery('<div class="badges"></div>');
    this.clearActions();
  }

  render() {
    jQuery.each(this.actions, (_, action) => {
      if (action.visible()) {
        return this.actionContainer.append(action.render().el);
      }
    });

    jQuery.each(this.badges, (_, action) => {
      if (action.visible()) {
        return this.badgeContainer.append(action.render().el);
      }
    });

    this.el.append(this.actionContainer, this.badgeContainer);

    return this;
  }

  // DSL

  clearActions() {
    this.actionContainer.empty();
    this.badgeContainer.empty();
    this.actions = [];
    return (this.badges = []);
  }

  addAction(name, options = {}) {
    return this.actions.push(new this.constructor.Action(name, options));
  }

  addBadge(name, options = {}) {
    return this.badges.push(new this.constructor.Action(name, options));
  }
};

if (_previousActionBar) {
  Object.assign(Sparkle.PageBuilder.Component.ActionBar, _previousActionBar);
}
